import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Define and run Change Risk Training`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=algorithms-change-risk" target="_blank">🌏 Documentation for the Task: Setting up training for change risk</a>
    <p>{`In this section you will set up and run training for this AI algorithm to determine `}<inlineCode parentName="p">{`how likely it is that a proposed change would cause a problem`}</inlineCode>{`.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <h2>{`Define Change Risk Training`}</h2>
        <ol>
          <li parentName="ol">{`In the `}<inlineCode parentName="li">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="li">{`Operate`}</inlineCode>{`/`}<inlineCode parentName="li">{`AI Model Management`}</inlineCode></li>
          <li parentName="ol">{`Under `}<inlineCode parentName="li">{`Change Risk`}</inlineCode>{`, click on `}<inlineCode parentName="li">{`Set up training`}</inlineCode></li>
          <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Next`}</inlineCode></li>
          <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Next`}</inlineCode></li>
          <li parentName="ol">{`Under `}<inlineCode parentName="li">{`Deployment type`}</inlineCode>{` check `}<inlineCode parentName="li">{`On completion`}</inlineCode></li>
          <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Done`}</inlineCode></li>
        </ol>
        <h2>{`Run Change Risk Training`}</h2>
        <ol>
          <li parentName="ol">{`Click on the the `}<inlineCode parentName="li">{`Change Risk`}</inlineCode>{` card`}</li>
          <li parentName="ol">{`Click on `}<inlineCode parentName="li">{`Train Models`}</inlineCode></li>
          <li parentName="ol">{`Status should say `}<inlineCode parentName="li">{`In progress`}</inlineCode></li>
          <li parentName="ol">{`And eventually say `}<inlineCode parentName="li">{`Deployed`}</inlineCode></li>
        </ol>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      